import { render, staticRenderFns } from "./VmUploadFile.vue?vue&type=template&id=28689e3a&scoped=true"
import script from "./VmUploadFile.vue?vue&type=script&lang=js"
export * from "./VmUploadFile.vue?vue&type=script&lang=js"
import style0 from "./VmUploadFile.vue?vue&type=style&index=0&id=28689e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28689e3a",
  null
  
)

export default component.exports